import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description: {
      mandatee: [
        'Unfortunately, it is impossible for us to open your client’s Shine account if they do not have a bank account in a French or European bank.',
        'International banking regulations impose strict rules on us in this kind of situation.',
      ],
      nonMandatee: [
        'Unfortunately, it is impossible for us to open your Shine account if you do not have a bank account in a French or European bank.',
        'International banking regulations impose strict rules on us in this kind of situation.',
      ],
    },
    title: {
      mandatee: 'We cannot open your client’s account',
      nonMandatee: 'We cannot open your account',
    },
  },
  fr: {
    description: {
      mandatee: [
        'Il nous est malheureusement impossible de procéder à l’ouverture du compte Shine de votre client s’il•elle ne possède pas de compte bancaire dans une banque Française ou Européenne.',
        'La réglementation bancaire internationale nous impose des règles strictes dans ce genre de situation.',
      ],
      nonMandatee: [
        'Il nous est malheureusement impossible de procéder à l’ouverture de votre compte Shine si vous n’avez pas de compte bancaire dans une banque Française ou Européenne.',
        'La réglementation bancaire internationale nous impose des règles strictes dans ce genre de situation.',
      ],
    },
    title: {
      mandatee:
        'Nous ne pouvons pas procéder à l’ouverture du compte de votre client',
      nonMandatee: 'Nous ne pouvons pas procéder à l’ouverture de votre compte',
    },
  },
} as const);
